import React from 'react';
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';

// Icon
import RonadIcons from '../iconComponent';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <RonadIcons name="times" size={0.8} />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);
type Props = {
  title?: React.ReactNode;
  content?: React.ReactNode;
  actions?: React.ReactNode;
  open: boolean;
  maxWidth?: false | 'sm' | 'xs' | 'md' | 'lg' | 'xl' | undefined;
  fullScreen?: boolean | undefined;
  onClose: () => void;
};

export default function Modals(props: Props) {
  const { onClose, title, content, actions, open, maxWidth, fullScreen, hideHeader } = props;

  return (
    <div>
      <Dialog
        maxWidth={maxWidth}
        fullScreen={fullScreen}
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        {!hideHeader && <DialogTitle id="customized-dialog-title" onClose={onClose}>
          {title}
        </DialogTitle>}
        <DialogContent>
          <Typography gutterBottom>{content}</Typography>
        </DialogContent>
        <DialogActions>{actions}</DialogActions>
      </Dialog>
    </div>
  );
}

Modals.defaultProps = {
  title: '',
  content: '',
  actions: '',
  open: false,
  maxWidth: 'xs',
  fullScreen: false,
  onClose: () => null,
};
